import { graphql, useStaticQuery } from "gatsby"

export const useFooterMenu2 = () => {
  const { allWpMenu } = useStaticQuery(
    graphql`
      query FOOTER_MENU_2 {
        allWpMenu(filter: { slug: { eq: "footer-menu-2" } }) {
          nodes {
            databaseId
            name
            count
            slug
            menuItems {
              nodes {
                id
                label
                url
              }
            }
          }
        }
      }
    `
  )

  const { nodes: [ node = {} ] } = allWpMenu
  const {
    menuItems: { nodes: menuItems = [] }
  } = node
  return [menuItems]
}